module.exports = __webpack_public_path__ + "img/buddy_mouth-05.5a1ff733.svg";